// extracted by mini-css-extract-plugin
export var container = "_ft-0";
export var outlet = "_ft-1";
export var outletEnter = "_ft-2";
export var outletEnterActive = "_ft-3";
export var outletExit = "_ft-4";
export var outletExitActive = "_ft-5";